import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Columns2, ExternalLink } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { Skeleton } from "./ui/skeleton";
import { API } from "../lib/api";
import { ComparePanel } from "./ComparePanel";

export const BothLensesTag = ({ r, onCompare }) => (
  <span className="mt-1 flex w-fit flex-wrap items-center gap-1 whitespace-nowrap rounded bg-[#FDEFE6] px-1.5 py-0.5 text-xs normal-case text-[var(--orange)]" data-testid={`admin-both-${r.id}`}>
    Both lenses:
    <Link to={`/results/${r.latest.staff}`} target="_blank" className="underline hover:text-[var(--ink)]" data-testid={`admin-both-staff-${r.id}`}>Staff</Link>|
    <Link to={`/results/${r.latest.manager}`} target="_blank" className="underline hover:text-[var(--ink)]" data-testid={`admin-both-manager-${r.id}`}>Manager</Link>
    <button type="button" onClick={() => onCompare(r)} className="ml-1 inline-flex items-center gap-0.5 font-semibold hover:text-[var(--ink)]" title="Compare side by side" data-testid={`admin-compare-${r.id}`}><Columns2 className="h-3 w-3" />Compare</button>
  </span>
);

const useBoth = (latest) => {
  const [pair, setPair] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    setPair(null);
    setErr(false);
    if (!latest) return;
    Promise.all([API.get(`/assessments/${latest.staff}`), API.get(`/assessments/${latest.manager}`)])
      .then(([s, m]) => setPair([s.data, m.data]))
      .catch(() => setErr(true));
  }, [latest]);
  return { pair, err };
};

export const AdminCompareDialog = ({ row, onClose }) => {
  const { pair, err } = useBoth(row?.latest);
  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] max-w-4xl overflow-y-auto bg-white" data-testid="admin-compare-dialog">
        <DialogTitle>{row?.name || "Unnamed"}<span className="ml-2 text-sm font-normal muted">{row?.email}</span></DialogTitle>
        <DialogDescription>Latest staff result vs latest manager result.</DialogDescription>
        {err && <p className="text-sm text-[var(--orange)]" data-testid="admin-compare-error">Couldn't load these results.</p>}
        {!pair && !err && <Skeleton className="h-64 w-full" />}
        {pair && <ComparePanel current={pair[0]} other={pair[1]} admin />}
        {row && (
          <div className="flex flex-wrap gap-2">
            <Link to={`/results/${row.latest.staff}`} target="_blank" className="btn btn-line" data-testid="admin-compare-open-staff"><ExternalLink className="h-4 w-4" /> Staff result</Link>
            <Link to={`/results/${row.latest.manager}`} target="_blank" className="btn btn-line" data-testid="admin-compare-open-manager"><ExternalLink className="h-4 w-4" /> Manager result</Link>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
